export default "__VITE_ASSET__dUiJwbi_88qwDMGeS6xicg__"